import React from 'react';
import { Link } from 'react-router';
import './ContactSuccess.scss';

const ContactSuccess = () =>
  (<main>
    <div className="container">
      <h1 className="contact-us-h1">Thanks for getting in touch</h1>
      <div className="contact-success-text-block">
        <div>
          One of the team will be in contact by email in the next 24 hours.
        </div>
        <div>
          While we&apos;re working on it, check out our <Link to={'support-centre'}>Support Centre</Link> to see our
          helpful FAQs.
        </div>
      </div>
    </div>
  </main>);

export default ContactSuccess;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ContactSuccess.js
 **/